//Shopify.formatMoney is often undefined when needed here, so we had to duplicate it
//CAREFUL, if a price type is string, then it multiplies it, but if it's number, it doesn't. WTF?
//always call this function with a number, not string
function sasoShopifyformatMoney(cents, format) {
  if (typeof cents == "undefined" || cents == null) {
    return ""
  }
  if (typeof cents == "string" && cents.length == 0) {
    return ""
  }
  //console.log("cents", cents, typeof cents) //we should always call this function with a number, not string
  if (typeof cents == "number" && window.saso_config.tax_percent > 0) {
    cents = cents * (1 + window.saso_config.tax_percent / 100)
  }

  var value = '',
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = (format || this.money_format);

  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

//put here, not in .liquid, Shopify render bug will break "<<"
//simple hash, no need for md5. Can be negative!
function sasoHash(s) {
  var hash = 0,
    i, chr, len;
  if (s.length === 0) return hash;
  for (i = 0, len = s.length; i < len; i++) {
    chr = s.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash.toString();
}

function sasoCleanBuyxHandleJson(product) {
  var variants = []
  //does it have BuyXDiscount option?
  var option_position = -1
  for (var oi = 0, olen = product.options.length; oi < olen; oi++) {
    if (product.options[oi].name == "BuyXDiscount") {
      option_position = oi + 1
      break
    }
  }
  //console.log(product)
  //console.log("buyx_product_json option_position", option_position)
  if (option_position == -1) {
    return product
  }
  if (product.options.length > 1) {
    product.options.splice(option_position - 1, 1)
  } else {
    product.options[0].name = "Title"
  }
  option_position = "option" + option_position
  product.available = false
  for (var vi = 0, vlen = product.variants.length; vi < vlen; vi++) {
    //console.log(product.variants[vi])
    if (product.variants[vi][option_position] == "Default") {
      product.variants[vi][option_position] = ""
      variants.push(product.variants[vi])
      product.available = product.available || product.variants[vi].available
    }
  }
  product.variants = variants
  //console.log(product.variants)
  product.price = product.variants[0].price
  product.price_min = product.price
  product.price_varies = false
  return product
}

function sasoCurrency() {
  //currency converters
  if (typeof Currency == "object" && typeof Currency.moneyFormats == "object" && typeof mlvedaload == "function") {
    mlvedaload()
  }

  /*if(typeof mlvedaload == "function") {
    mlvedaload()
  }*/
}


function sasoDoActions(data) {
  if (typeof SASOComplete == "function") {
    data = SASOComplete(data)
  }
  window.saso_config.notifications = data.settings_notifications
  if (typeof window.saso_config.notifications != "object") {
    window.saso_config.notifications = []
  }
  if (typeof window.saso_config.notifications.position != "string") {
    window.saso_config.notifications.position = "top"
  }
  if (typeof window.saso_config.notifications.background_color != "string") {
    window.saso_config.notifications.background_color = "#73170f"
  }
  if (typeof window.saso_config.notifications.text_color != "string") {
    window.saso_config.notifications.text_color = "#ffffff"
  }

  window.saso_config.tax_percent = data.tax_percent
  window.saso_config.offers_method = data.offers_method
  window.saso_config.exclude_order_discount_details = false
  if (typeof data.exclude_order_discount_details == "boolean") {
    window.saso_config.exclude_order_discount_details = data.exclude_order_discount_details
  }

  //actions, discounts... multiple top-level stuff
  //console.dir(actions)

  if (typeof data.actions != "object") {
    data.actions = []
  }
  var af = []

  /*af = data.actions.filter(function(a) {
    return a.type == "update-cart-items"
  })
  if (af.length) {
    sasoUpdateCartItems(af[0].updates)
  }*/
  //can be multiple adds, but only one action
  af = data.actions.filter(function (a) {
    return a.type == "add-cart-items"
  })
  if (af.length) {
    sasoAddCartItems(af[0].items)
  }

  af = data.actions.filter(function (a) {
    return a.type == "volume-discount-tiers"
  })
  if (af.length) {
    sasoShowVolumeDiscountTiers(af[0]) //only 1st, in case there are more offers on the same product, e.g. public gets 10%, vip gets 25%
  }

  var cooka = []
  var cook = window.sasoDocCookies.getItem("saso_shown_upsells")
  if (cook && typeof cook == "string") {
    cook.split(",").map(function (i) {
      cooka.push(parseInt(i))
    })
  }
  af = data.actions.filter(function (a) {
    //exclude those already shown
    if (a.type == "Upsell") {
      if (cooka.indexOf(a.id) == -1) {
        return true
      }
    }
    return false
  })
  if (af.length) {
    //console.log(af)
    //just one. embed view will set a shown key too, with 1minute expiration

    //prioritze discounted upsells
    var af2 = af.filter(function (action) {
      return (typeof action.price_discount == "object" && action.price_discount)
    })
    if (af2.length) {
      //console.log(af2)
      af = af2
    }

    //show a random one from all not shown
    sasoPrepareCrossSell(af[Math.floor(Math.random() * af.length)])
  }


  af = data.actions.filter(function (a) {
    if (a.type == "Bundle") {
      return true
    }
    return false
  })
  if (af.length) {
    //show a random one, if more
    sasoPrepareBundle(af[Math.floor(Math.random() * af.length)])
  }



  af = data.actions.filter(function (a) {
    return a.type == "notification"
  })
  if (af.length) {
    sasoShowNotifications(af)
  }

  if (typeof data.discounts == "object" && typeof data.discounts.cart == "object" && typeof data.discounts.cart.items == "object") {
    sasoShowCartDiscounts(data.discounts)
  }


  //if no cross-sells for this product, don't check again in cart
  /* offer might not be applicable now, but could be later, e.g. cart amount,
  Crosssell should have less Applicability (no cart amount, no has product in cart...)
  */
  /*if (window.saso.page_type == "product" && !has_crosssell) {
    sasoShowCrossSellShown(window.saso.product.id)
  }*/

  //more reliable way to check cart items changed: check cart count every 1 sec, and reload page if changed. NO kills CPU
}


function sasoHideNotification(hash) {
  //console.log("sasoHideNotification", jQuery(".saso-notification").css("top"),  jQuery(".saso-notification").css("bottom"))
  //if (jQuery(".saso-notification").css("top") == "0px") {
  jQuery(".saso-notification").slideUp("fast")
  /*} else {
    jQuery(".saso-notification").slideDown("fast")
  }*/
  var cooka = []
  var cook = window.sasoDocCookies.getItem("saso_notifications_closed")
  if (cook && typeof cook == "string") {
    cooka = cook.split(",")
  }
  if (cooka.indexOf(hash) == -1) {
    cooka.push(hash)
  }
  window.sasoDocCookies.setItem("saso_notifications_closed", cooka.join(","), window.saso_config.hide_closed_notifications_for, "/")
}

function sasoShowNotifications(notifications) {
  //console.log("sasoShowNotification")
  //how to handle multiple? concatenate
  //at top it often overlaps with menu
  //in some themes, try to put in custom places, unless we added a class to ignore that. Some themes require before/prepend...
  //but only if position is set to "top". Owner might want bottom.
  if (window.saso_config.notifications.position == "top") {
    var divn = '<div id="saso-notifications" style="padding-top: 0px; "></div>'
    //don't use [".."].map(), it doesn't work
    //turbo
    var checks = [".collection_banner"]
    checks.map(function (sel) {
      if (jQuery("#saso-notifications").length == 0 && jQuery(sel + ":not(.saso-ignore)").length == 1) {
        jQuery(sel).after(divn)
      }
    })

    //turbo
    //, "#shopify-section-product-template .main" -- breaks parallax
    //turbo cart page: on mobile, menu cover notifications
    if (jQuery("#shopify-section-cart-template .section").length) {
      jQuery("#shopify-section-cart-template .section").first().after(divn)
    }

    //https://steampunkarchipelago.com/collections/helmets/products/dot-certified-vintage-70s-helmets
    //https://www.upscaleaudio.com/collections/turntables
    var checks = ["main.wrapper.main-content", "main.main-content"]
    checks.map(function (sel) {
      if (jQuery("#saso-notifications").length == 0 && jQuery(sel + ":not(.saso-ignore)").length == 1) {
        jQuery(sel).before(divn)
      }
    })

    //https://kawaiination.com/collections/k-pop/products/snap-hearts-embroidery-canvas-backpack
    var checks = ["div.content", "section.main-content"]
    checks.map(function (sel) {
      if (jQuery("#saso-notifications").length == 0 && jQuery(sel + ":not(.saso-ignore)").length == 1) {
        jQuery(sel).prepend(divn)
      }
    })

    var checks = ["main"]
    checks.map(function (sel) {
      if (jQuery("#saso-notifications").length == 0 && jQuery(sel + ":not(.saso-ignore)").length == 1) {
        jQuery(sel).before(divn)
      }
    })

  }

  var notification_messages = []
  notifications.map(function (n) {
    if (notification_messages.indexOf(n.message) == -1) { //only unique
      notification_messages.push(n.message)
    }
  })
  var message = notification_messages.join("<br>")

  var hash = sasoHash(message)
  var cooka = []
  var cook = window.sasoDocCookies.getItem("saso_notifications_closed")
  if (cook && typeof cook == "string") {
    cooka = cook.split(",")
  }
  if (cooka.indexOf(hash) > -1) {
    return
  }

  var style = 'background-color: ' + window.saso_config.notifications.background_color + '; color: ' + window.saso_config.notifications.text_color + ';'
  var style_container = style + 'opacity: ' + window.saso_config.notifications.opacity + '; '
  if (jQuery("#saso-notifications").length) { } else {
    style_container += 'position: fixed; ' + window.saso_config.notifications.position + ': 0; '
  }
  var html = '<div class="saso-notification" style="' + style_container + '"><div class="saso-notification-x"><a href="#" style="" onclick="sasoHideNotification(\'' + hash + '\'); return false;">X</a></div>'
  html += '<p style="' + style + '">' + message + '</p></div>'
  html += '<style> .saso-notification a { ' + style + ' }'
  //window.saso_config.notifications_require_container ||
  if (jQuery("#saso-notifications").length) {
    jQuery("#saso-notifications").html(html)
  } else {
    jQuery(document.body).append(html)
  }

  jQuery(".saso-notification").slideDown("slow")
  /*setTimeout(function () {
    if (jQuery(".saso-notification").css("top") == "0px") {
    } else {
      jQuery(".saso-notification").slideUp("slow")
    }
  }, 10)*/

  /*setTimeout(function () {
    sasoHideNotification()
  }, 5000)*/
}

//TODO who calls this?? used to be gift
/*function sasoAddToCart(action) {
  var defs = []
  var products = []
  action.products.map(function(p) {
    defs.push(jQuery.getJSON("/products/" + p.handle + ".json", function( data ) {
      var product = data.product
      products.push(product)
    }))
  })

  jQuery.when.apply(jQuery, defs).done(function() {
    //console.log("sasoAddToCart", products)
    var products_add = []
    products.map(function(product) {
      if (product.variants.length == 1) {
          products_add.push("updates[" + product.variants[0].id + "]=1")
      }
    })
    if (products_add.length == 0) {
      //nothing to add
      return
    }


    jQuery.ajax({
      type: "POST",
      dataType: "text",
      url: '/cart/update.js',
      data: products_add.join(","),
      success: function(done_data) {
        //sometimes cart doesn't actually contain the product??
        setTimeout(function() {
            window.location.reload()
        }, 100)
      }
    })


  })
}
*/

/*
Ajax requests that update the cart must be queued and sent synchronously to the server.
Meaning: you must wait for your 1st ajax callback, to send your 2nd request, and then wait for its callback to send your 3rd request, etc
*/
function sasoAddCartItems(items, callback) {

  // If we still have requests in the queue, let's process the next one.
  if (items.length) {
    var item = items.shift()
    jQuery.ajax({
      type: "POST",
      dataType: "json",
      url: '/cart/add.js',
      data: item,
      success: function (res) {
        sasoAddCartItems(items, callback)
      },
      error: function (res) {
        //console.log("err", res)
        if (typeof res == "object" && typeof res.responseJSON == "object" && typeof res.responseJSON.description == "string") {
          alert(res.responseJSON.description)
        }
        if (typeof res == "string") {
          alert(res)
        }
      }
    })

  } else {
    //added all
    if (typeof callback == "function") {
      return callback()
    }
    //sometimes cart doesn't actually contain the product??
    setTimeout(function () {
      window.location.reload()
    }, 200)
  }
}
/*
function sasoUpdateCartItems(updates) {
  var updates_request = []
  updates.map(function(u) {
    updates_request.push("updates[" + u.variant_id + "]=" + u.quantity)
  })
  jQuery.ajax({
    type: "POST",
    dataType: "text",
    url: '/cart/update.js',
    data: updates_request.join(","),
    success: function(done_data) {
      //sometimes cart doesn't actually contain the product??
      setTimeout(function() {
        window.location.reload()
      }, 200)
    }
  })

}*/


function sasoPrepareCrossSell(action) {

  if (typeof window.saso_config.show_upsell_only_in == "string" && window.saso_config.show_upsell_only_in.length) {
    if (window.saso_config.show_upsell_only_in.indexOf(window.saso.page_type) == -1) {
      return
    }
  }

  if (typeof window.saso_config.show_upsell_only_width_larger == "number") {
    if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < window.saso_config.show_upsell_only_width_larger) {
      //show as notification instead
      sasoShowNotifications([
        { type: "notification", message: action.message }
      ])

      return
    }
  }

  //console.log("sasoPrepareCrossSell", action)
  var defs = []
  var products = []
  action.products.map(function (p) {
    //exclude products proposed for upsell that are already in cart -- NO, might be a Buy 1 Get 1 for the same product
    //this won't work well for 100% discounted Buy X offers, after adding 2x more products to get the offer again. Would have to change qty manually
    //that's ok, safer than keep auto-adding because of possible bugs
    /*if (window.saso.cart) {
      var p_in_cart = window.saso.cart.items.filter(function(item) {
        return (item.product_id == p.id)
      })
      if (p_in_cart.length > 0) {
        //don't include again
        return
      }
    }*/

    //exclude current product from the upsell popup
    if (window.saso.page_type == "product" && p.id == window.saso.product.id) {
      return
    }

    defs.push(jQuery.getJSON("/products/" + p.handle + ".json", function (data) {

      var product = data.product
      product = sasoCleanBuyxHandleJson(product)

      for (var i = 0; i < product.variants.length; i++) {
        //transform prices from $ strings to cents float
        if (typeof product.variants[i].compare_at_price == "string") {
          product.variants[i].compare_at_price = parseFloat(product.variants[i].compare_at_price) * 100
        }
        if (typeof product.variants[i].price == "string") {
          product.variants[i].price = parseFloat(product.variants[i].price) * 100
        }

        //some upsells can show discounted prices
        if (typeof action.price_discount == "object" && action.price_discount && typeof action.price_discount.amount == "number") {
          //put original variant price as compare, so people can clearly see half price
          //if (product.variants[i].compare_at_price == null || product.variants[i].compare_at_price == 0) {}
          product.variants[i].compare_at_price = product.variants[i].price
          switch (action.price_discount.type) {
            case "flat":
              product.variants[i].price = action.price_discount.amount * 100 //cents
              break
            case "subtract":
              product.variants[i].price -= action.price_discount.amount * 100 //cents
              if (product.variants[i].price < 0) {
                product.variants[i].price = 0
              }
              break
            case "percent":
              product.variants[i].price = product.variants[i].price * (100 - action.price_discount.amount) / 100
              break
          }
        }

        //from here on, transform prices to formatted strings
        product.variants[i].compare_at_price_n = product.variants[i].compare_at_price
        product.variants[i].price_n = product.variants[i].price
        if (product.variants[i].compare_at_price && product.variants[i].compare_at_price > product.variants[i].price) {
          product.variants[i].compare_at_price = sasoShopifyformatMoney(product.variants[i].compare_at_price, window.saso.money_format)
        } else {
          product.variants[i].compare_at_price = ""
        }
        product.variants[i].price = sasoShopifyformatMoney(product.variants[i].price, window.saso.money_format)
      }

      product.variants_style = ""
      product.variants_select = ""
      if (product.variants.length == 1) {
        product.variants_style = "visibility: hidden;"
        //legacy templates
        product.style_options = "visibility: hidden;"
      } else {
        var variants_html = ""
        product.variants.map(function (v) {
          //only in stock
          //console.log(v.inventory_management, v.inventory_policy, v.inventory_quantity)
          if (typeof v.inventory_management == "string" && v.inventory_management == 'shopify') {
            if (typeof v.inventory_policy == "string" && v.inventory_policy == 'deny' && typeof v.inventory_quantity == "number" && v.inventory_quantity <= 0) {
              return
            }
          }
          var img = ""
          if (typeof v.image_id == "number" && v.image_id != null) {
            var vimages = product.images.filter(function (pi) {
              return pi.id == v.image_id
            })
            if (vimages.length) {
              img = vimages[0].src
            }
          } else {
            //null, show default
            if (typeof product.image == "object" && product.image && typeof product.image.src == "string") {
              img = product.image.src
            }
          }
          //load a smaller image size
          var n = img.lastIndexOf(".") //blah.blah.jpg?v=123
          if (n >= 0) {
            var s = img.substring(0, n) + "_medium." + img.substring(n + 1)
            img = s
          }
          variants_html += "<option value='" + v.id + "' data-img='" + img + "' data-price='" + v.price_n + "' data-compare-at-price='" + v.compare_at_price_n + "'>"
          variants_html += sasoEscapeHtml(v.title) + "</option>"
        })
        product.variants_select = "<select class='saso-variants'>"
        if (typeof window.saso_config.upsell_variant_choose_option == "string" && window.saso_config.upsell_variant_choose_option.length) {
          product.variants_select += "<option value='0'>" + sasoEscapeHtml(window.saso_config.upsell_variant_choose_option) + "</option>"
        }
        product.variants_select += variants_html + "</select>"
      }
      //load a smaller image size
      //var product = {image: {src: "blah.blah.jpg?v=123"}}
      if (typeof product.image == "object" && product.image && typeof product.image.src == "string") {
        var n = product.image.src.lastIndexOf(".") //blah.blah.jpg?v=123
        if (n >= 0) {
          var s = product.image.src.substring(0, n) + "_medium." + product.image.src.substring(n + 1)
          product.image.src = s
        }
      }
      product.title = sasoTrimLength(product.title, window.saso_config.product_title_max_length)

      products.push(product)
    }).fail(function () {
      //console.log( "error" ); this shows
      //return jQuery.Deferred().resolve({}).promise() doesn't
      //http://stackoverflow.com/questions/6259301/jquery-deferred-turn-failure-into-success
    })
    ) //push
  })

  if (defs.length == 0) {
    return
  }

  jQuery.when.apply(jQuery, defs).done(function () {
    //console.log("sasoPrepareCrossSell", products)
    if (products.length == 0) {
      //all products out of stock
      return
    }
    window.saso.action_crosssell_popup_action = action //used by sasoShowCrossSellClosed()
    //only if upsells are for other gifts, not Buy X
    window.saso.ignore_previous_free_gifts = true
    if (typeof action.from_offer_type == "string" && action.from_offer_type == "Free Gift") {
      window.saso.ignore_previous_free_gifts = false
    }

    //if there's just 1 product with 1 variant to add, and it's free, auto-add
    //do this now, before products how_many
    if (products.length == 1 && products[0].variants.length == 1 && products[0].variants[0].price_n == 0) {
      sasoRemovePreviousFreeGifts(function () {
        sasoAddCartItems([{
          id: products[0].variants[0].id,
          quantity: 1
        }])

        //if out of stock, the product would have been excluded
        //mark this one as shown, so other upsells keep working. That's why we have the code after setting popup title
        sasoShowCrossSellClosed()
      })
      return //don't show the popup at all
    }


    //if all products don't have any variants, fully remove variants container to save space
    var no_variants = true
    for (var i = 0; i < products.length; i++) {
      if (products[i].variants.length > 1) {
        no_variants = false
      }
    }
    if (no_variants) {
      for (var i = 0; i < products.length; i++) {
        //products[i].variants_style = "display: none;"
        products[i].variants_style = "height: 0px;"
      }
    }

    var popup_tpl = Handlebars.compile(jQuery('#saso-cross-sell-popup').html())
    window.saso.action_crosssell_popup_html = popup_tpl({
      notifications_message: action.message,
      products: products,
      click_here: action.click_here
    })

    //if we're in cart, show it, othwerwise for to click "Add to cart" button in product page
    if (window.saso.page_type == "cart") {
      sasoShowCrossSell(action)
    }

    //if (action.when == "add-to-cart") {
    //always show on add to cart, if remaining on that page
    //}

    /*if (action.when == "checkout") {
      //var selectors = ["input[name='checkout']", "button[name='checkout']", "input[name='goto_pp']", "button[name='goto_pp']", "input[name='goto_gc']", "button[name='goto_gc']", "[href$='checkout']"];
      //allow other checks, e.g. Agree to terms, to trigger before actually starting checkout, otherwise we'll submit without checks
      //var selectors = ["#cartform", "#cart-form"]
      var selectors = ['form[action^="/cart"]', 'form[action^="/checkout"]']
      selectors.forEach(function(selector) {
        //jQuery(selector).on("click", function(e) {
        jQuery(selector).on("submit", function(e) {
            //console.log(window.saso.clicked_button_id) //update-cart
            //if ((typeof window.saso.clicked_button_id == "string") && window.saso.clicked_button_id.toLowerCase().indexOf("update") > -1) {
              //avoid showing on Update cart
              //return
            //}
          //only if checkout button
          if ((typeof window.saso.clicked_button_name == "string") && window.saso.clicked_button_name.toLowerCase().indexOf("checkout") > -1) {
            window.saso.action_crosssell_el = { $el: $( this )}
              return sasoShowCrossSell({action_when: action.when})
          }

        })
      })

      var selectors_links = ['a[href^="/checkout"]']
      selectors_links.forEach(function(selector) {
        jQuery(selector).on("click", function(e) {
            window.saso.action_crosssell_el = { $el: $( this )}
              return sasoShowCrossSell({action_when: action.when})
        })
      })

    }*/
  })

}


function sasoShowCrossSell(action) {
  //console.log("sasoShowCrossSell", window.saso.action_crosssell_product_id )
  //show only once for each product id. Remember for some time.
  /*if (window.saso.page_type == "product") {
    //already have all details
    //because one clicked Add from product detail page, always show, even if seen.
    window.saso.action_crosssell_product_id = window.saso.product.id
  }*/
  //window.saso.action_crosssell_product_id = action.for_product_id

  //just in case data prep didn't complete
  if (typeof window.saso.action_crosssell_popup_html != "string") {
    return
  }


  //don't remember if a product doesn't have upsells, as the store owner might just add an offer to test


  //have a 1.5s delay, in case theme redirects after "Add to cart", avoid popup flashes
  //also, in case there are AJAX cart popups, try again to show in cart
  setTimeout(function () {

    //popup or embed?
    window.sasoc.$cart_offers = jQuery(".saso-cart-offers")
    //console.log("show popup?", window.sasoc.$cart_offers.length)
    if (window.sasoc.$cart_offers.length) {
      window.sasoc.$cart_offers.each(function (i) {
        jQuery(this).html(window.saso.action_crosssell_popup_html)
      })
      sasoCurrency()
      //mark as viewed so we can cycle upsells, but for only 1 minute
      sasoShowCrossSellClosed()
      return
    }
    //console.log("show popup")

    if (window.saso_config.crosssell_never_show_popup) {
      return
    }

    //jQuery.magnificPopup is sometimes undefined, probably other jQuery loaded
    window.sasoc.magnificPopup.open({
      closeOnContentClick: false,
      closeOnBgClick: false,
      //alignTop: true, //vertical centering doesn't work properly on mobile, it appears outside viewport, way down. This solves it, but breaks desktop, puts it at very top
      items: {
        //https://github.com/dimsemenov/Magnific-Popup/issues/131
        src: jQuery.parseHTML(window.saso.action_crosssell_popup_html),
        type: 'inline'
      },
      callbacks: {
        afterClose: function () {
          sasoShowCrossSellClosed()

          //if we're in cart page, reload it, so newly added product also appears
          //but only if we actually added a product
          if (window.saso.page_type == "cart" && typeof window.saso.upsell_added == "boolean" && window.saso.upsell_added) {
            location.reload()
          }

          /*if (data.action_when == "checkout") {
                  window.location = "/checkout" + (typeof jQuery("#discount").val() == "string" ? "?discount=" + jQuery("#discount").val() : "")
                } else if (window.saso_config.crosssell_continue_after_close) {
                  console.log("crosssell_continue_after_close")
                  window.saso.action_crosssell_el.$el.click()
                }*/
        }
      }
    })

    sasoCurrency()

    //AHHH. If we set width: auto; for popup content, it breaks responsiveness, introduces issues with proper screen fitting on small screens.
    //https://github.com/dimsemenov/Magnific-Popup/issues/324 -- leave width to 100%, set max-width
    setTimeout(function () {
      //console.log(jQuery(".saso-products-container"))
      if (jQuery(".saso-products-container table").length) {
        //console.log(jQuery(".saso-products-container table").width())
        jQuery(".mfp-content").css("max-width", jQuery(".saso-products-container table").width() + 100)
      }
    }, 100)


    setTimeout(function () {
      //after 0.4 sec of showing, mark upsell for product id as seen.
      //Leave some time in case there's a redirect to cart, but less than 1sec in case people close it quickly
      //sasoShowCrossSellShown(action.for_product_id)
      sasoShowCrossSellClosed()
    }, 600)

  }, 1500)

}

//avoid annoying users after manually closing: don't show this upsell offer for any product, for a while
function sasoShowCrossSellClosed() {
  //console.log('closed', window.saso.page_type)
  if (window.sasoc.$cart_offers.length) {
    //embeds hide it only for 10 seconds, to cycle all upsells. Should use random() on multiple upsells
    window.saso_config.hide_shown_upsells_for = 10
  }

  var cooka = []
  var cook = window.sasoDocCookies.getItem("saso_shown_upsells")
  if (cook && typeof cook == "string") {
    cook.split(",").map(function (i) {
      cooka.push(parseInt(i))
    })
  }
  var a = window.saso.action_crosssell_popup_action
  if (cooka.indexOf(a.id) == -1) {
    //don't remember when it was free, server won't send next time if already in cart. In case user removes from cart, re-add
    //don't remember when it was more than 50% discouted
    /*if (typeof a.price_discount == "object" && a.price_discount && (
      (a.price_discount.type == "percent" && a.price_discount.amount == "100") || (a.price_discount.type == "flat" && a.price_discount.amount == "0")
    )) {} else {
    */
    if (typeof window.saso.action_crosssell_popup_action.manually_closed == "boolean" && window.saso.action_crosssell_popup_action.manually_closed) {
      //don't show again
      cooka.push(a.id)
    } else if (typeof a.price_discount == "object" && a.price_discount) {
      //&& ((a.price_discount.type == "percent" && a.price_discount.amount > 50) || (a.price_discount.type == "flat" && a.price_discount.amount < 20))
      //don't remember as closed, show again
    } else if (typeof a.price_bundle == "object" && a.price_bundle) {
      //don't remember as closed, show again
    } else {
      cooka.push(a.id)
    }
  }
  window.sasoDocCookies.setItem("saso_shown_upsells", cooka.join(","), window.saso_config.hide_shown_upsells_for, "/")
}





function sasoPrepareBundle(action) {
  var defs = []
  var products = []
  action.products.map(function (p) {

    defs.push(jQuery.getJSON("/products/" + p.handle + ".json", function (data) {

      var product = data.product
      for (var i = 0; i < product.variants.length; i++) {
        //transform prices from $ strings to cents float
        if (typeof product.variants[i].compare_at_price == "string") {
          product.variants[i].compare_at_price = parseFloat(product.variants[i].compare_at_price) * 100
        }
        if (typeof product.variants[i].price == "string") {
          product.variants[i].price = parseFloat(product.variants[i].price) * 100
        }


        //from here on, transform prices to formatted strings
        product.variants[i].compare_at_price_n = product.variants[i].compare_at_price
        product.variants[i].price_n = product.variants[i].price
        if (product.variants[i].compare_at_price && product.variants[i].compare_at_price > product.variants[i].price) {
          product.variants[i].compare_at_price = sasoShopifyformatMoney(product.variants[i].compare_at_price, window.saso.money_format)
        } else {
          product.variants[i].compare_at_price = ""
        }
        product.variants[i].price = sasoShopifyformatMoney(product.variants[i].price, window.saso.money_format)
      }

      product.variants_style = ""
      product.variants_select = ""
      if (product.variants.length == 1) {
        product.variants_style = "visibility: hidden;"
        //legacy templates
        product.style_options = "visibility: hidden;"
      } else {
        var variants_html = ""
        product.variants.map(function (v) {
          //only in stock -- this was removed in recent stores, rely on database for product level, variants unknown
          //console.log(v.inventory_management, v.inventory_policy, v.inventory_quantity)
          if (typeof v.inventory_management == "string" && v.inventory_management == 'shopify') {
            if (typeof v.inventory_policy == "string" && v.inventory_policy == 'deny' && typeof v.inventory_quantity == "number" && v.inventory_quantity <= 0) {
              return
            }
          }
          var img = ""
          if (typeof v.image_id == "number" && v.image_id != null) {
            var vimages = product.images.filter(function (pi) {
              return pi.id == v.image_id
            })
            if (vimages.length) {
              img = vimages[0].src
            }
          } else {
            //null, show default
            if (typeof product.image == "object" && product.image && typeof product.image.src == "string") {
              img = product.image.src
            }
          }
          //load a smaller image size
          var n = img.lastIndexOf(".") //blah.blah.jpg?v=123
          if (n >= 0) {
            var s = img.substring(0, n) + "_medium." + img.substring(n + 1)
            img = s
          }
          variants_html += "<option value='" + v.id + "' data-img='" + img + "' data-price='" + v.price_n + "' data-compare-at-price='" + v.compare_at_price_n + "'>"
          variants_html += sasoEscapeHtml(v.title) + "</option>"
        })
        product.variants_select = "<select class='saso-variants'>"
        if (typeof window.saso_config.upsell_variant_choose_option == "string" && window.saso_config.upsell_variant_choose_option.length) {
          product.variants_select += "<option value='0'>" + sasoEscapeHtml(window.saso_config.upsell_variant_choose_option) + "</option>"
        }
        product.variants_select += variants_html + "</select>"
      }
      //load a smaller image size
      //var product = {image: {src: "blah.blah.jpg?v=123"}}
      if (typeof product.image == "object" && product.image && typeof product.image.src == "string") {
        var n = product.image.src.lastIndexOf(".") //blah.blah.jpg?v=123
        if (n >= 0) {
          var s = product.image.src.substring(0, n) + "_medium." + product.image.src.substring(n + 1)
          product.image.src = s
        }
      }
      product.title = sasoTrimLength(product.title, window.saso_config.product_title_max_length)

      products.push(product)
    }).fail(function () {
      //console.log( "error" ); this shows
      //return jQuery.Deferred().resolve({}).promise() doesn't
      //http://stackoverflow.com/questions/6259301/jquery-deferred-turn-failure-into-success
    })
    ) //push
  })

  if (defs.length == 0) {
    return
  }

  jQuery.when.apply(jQuery, defs).done(function () {
    if (products.length == 0) {
      //all products out of stock
      return
    }

    //if all products don't have any variants, fully remove variants container to save space
    var no_variants = true
    for (var i = 0; i < products.length; i++) {
      if (products[i].variants.length > 1) {
        no_variants = false
      }
      products[i].quantity = 1
      products[i].quantityx = ""
      var currentp = action.products.filter(function (p) {
        return p.id == products[i].id
      })
      if (currentp.length == 1 && currentp[0].quantity > 1) {
        products[i].quantityx = currentp[0].quantity + "x"
        products[i].quantity = currentp[0].quantity
      }

    }
    if (no_variants) {
      for (var i = 0; i < products.length; i++) {
        //products[i].variants_style = "display: none;"
        products[i].variants_style = "height: 0px;"
      }
    }

    if (typeof window.saso_config.translate_percent_off == "string") {
      action.price.title = action.price.title.replace("% Off", window.saso_config.translate_percent_off)
    }

    //if template is missing... Just add to all templates
    var tpl = Handlebars.compile(jQuery('#saso-bundle-popup').html())
    var tpl_data = {
      notifications_message: action.message,
      products: products,
      bundle_price_type: action.price.type,
      bundle_price_title: action.price.title,
      message_after: action.message_after
    }
    var html = tpl(tpl_data)

    jQuery(".saso-bundle").html(html)
    sasoCurrency()

    //responsive. Media queries depend on screen, we need container width
    /*if (jQuery(".saso-bundle").width() > jQuery(".saso-bundle").parent().width()) {
      jQuery(".saso-bundle").addClass("saso-bundle-small")
    }*/

  })

}


function sasoBundleAddToCart(ev) {
  ev.preventDefault() //cart is submitted when inside <form>

  //variants & quantities

  var items_to_add = []
  var items_to_add_count = 0
  jQuery(".saso-product-container").each(function () {
    var item = {
      id: jQuery(this).data("variant-id"),
      quantity: jQuery(this).data("quantity")
    }
    var product_id = jQuery(this).data("product-id")
    items_to_add_count++

    //variant chosen?
    var $variants = jQuery(".saso-product-container[data-product-id='" + product_id + "']").find("select.saso-variants")
    if ($variants.length == 1) {
      var variant_id = parseInt($variants.val())
      if (variant_id == 0) {
        alert(window.saso_config.upsell_variant_choose_message)
        return
      }
      item.id = variant_id
    }

    items_to_add.push(item)
  })

  //console.log(items_to_add)
  //some variants might not have been selected. Add only if all items are ready
  if (items_to_add.length != items_to_add_count) {
    return
  }
  sasoAddCartItems(items_to_add, function () {
    /*jQuery(".saso-bundle-add-to-cart").fadeOut("slow", function() {
      jQuery(".saso-bundle-success").css("display", "block")
    })*/
    //sometimes cart doesn't actually contain the product??
    setTimeout(function () {
      window.location.href = "/cart" //might be in ajax cart, so always "reload" and show to customers that product has been added
    }, 100)

  })

}




function sasoShowCartDiscounts(discounts) {
  window.saso.discounts = discounts
  //used to set free gift to 0 when checking I will be using a coupon, and removing free gift when adding next tier
  //used to set summary_note too

  discounts.cart.items.forEach(function (item) {
    if (item.discounted_price < item.original_price) {
      jQuery(".saso-cart-item-discount-notes[data-key='" + item.key + "']").html(item.discount_notes.join("<br>"))
      jQuery(".saso-cart-item-price[data-key='" + item.key + "']").html("<span class='original_price'>" + item.original_price_format + "</span>" + "<span class='discounted_price'>" + item.discounted_price_format + "</span>")
      jQuery(".saso-cart-item-line-price[data-key='" + item.key + "']").html("<span class='original_price'>" + item.original_line_price_format + "</span>" + "<span class='discounted_price'>" + item.discounted_line_price_format + "</span>")
    }
    if (item.upsell_notes.length > 0) {
      var un = item.upsell_notes.join("<br>")
      if (typeof window.saso_config.translate_percent_off == "string") {
        un = un.replace("% Off", window.saso_config.translate_percent_off)
      }
      jQuery(".saso-cart-item-upsell-notes[data-key='" + item.key + "']").html(un)
    }

  })

  if (typeof discounts.discounted_price_html != "string") {
    //no discounts
    return
  }

  if (typeof discounts.allow_use_discount_code_cart == "boolean" && discounts.allow_use_discount_code_cart) {
    var html_d = '<div class="saso-use-discount-code-cart-container"><input type="text" class="saso-use-discount-code-cart-code" placeholder="Discount code"> '
      + '<button type="button" class="saso-use-discount-code-cart-apply btn btn--secondary">Apply</button></div>'
    if (jQuery('#saso-use-discount-code-cart').length == 1) {
      html_d = jQuery('#saso-use-discount-code-cart').html()
    }
    discounts.summary_html += html_d
  }
  if (typeof discounts.allow_use_discount_code_instead == "boolean" && discounts.allow_use_discount_code_instead) {
    var html_d = '<div><label style="font-weight: normal; cursor: pointer;"><input type="checkbox" id="saso-use-discount-code-instead-check"> I will be using a discount code instead</label></div>'
    if (jQuery('#saso-use-discount-instead').length == 1) {
      html_d = jQuery('#saso-use-discount-instead').html()
    }
    discounts.summary_html += html_d
  }

  jQuery(".saso-summary").html(discounts.summary_html)

  if (window.sasoDocCookies.getItem("saso_discount_code")) {
    //keep only if valid
    if (typeof discounts.discount_code_cart_valid != "boolean") { //true or nothing
      window.sasoDocCookies.removeItem("saso_discount_code")
      if (typeof window.saso.discount_code_cart == "string") {
        delete window.saso.discount_code_cart
      }
    } else {
      //previous code was using id, but some themes have 2 carts (mobile & desktop), we need to use class and keep id working too
      jQuery(".saso-use-discount-code-cart-code").val(window.sasoDocCookies.getItem("saso_discount_code"))
      jQuery("#saso-use-discount-code-cart-code").val(window.sasoDocCookies.getItem("saso_discount_code"))
    }
  }

  jQuery(".saso-note").val(discounts.cart.summary_note)
  jQuery(".saso-cart-original-total").css("text-decoration", "line-through")
  jQuery(".saso-cart-total").html(discounts.discounted_price_html)
  sasoCurrency()

  //try to disable other apps listening on checkout
  /*jQuery("form[action='/cart']").data("saso", true).data("ocu-checkout", true)
  jQuery("form[action='/checkout']").data("saso", true).data("ocu-checkout", true)*/
  //document.querySelectorAll("form[action='/cart']")


  //hijack Checkout buttons
  /*  var additional_checkout_selectors = ["input[name='goto_pp']", "button[name='goto_pp']", "input[name='goto_gc']", "button[name='goto_gc']", ".google-wallet-button-holder", ".amazon-payments-pay-button"];
    additional_checkout_selectors.forEach(function(selector) {
      jQuery(selector).remove()
    })
  */

  //other apps might take over, eg
  //jq310('body').on('click', upsell_checkout_button_selectors, upsellsCheckoutRedirect);
  //The handlers will execute in the order in which they were bound.
  /*
  var jqs = ["jQuery"] //, "jQuery191"
  jqs.map(function(jq) {
    if (typeof window[jq] == "function") {
      var checkout_selectors = ["form[action='/cart']", "input[name='checkout']", "button[name='checkout']", "[href$='checkout']"];
      checkout_selectors.forEach(function(selector) {
        var jels = window[jq](selector)
        if (typeof jels == "object" && typeof jels.off == "function") {
          jels.off()
        }
      })
    }
  })*/


  var checkout_selectors = ["input[name='checkout']:not(.bold_clone)", "button[name='checkout']", "[href$='checkout']", "input[name='goto_pp']", "button[name='goto_pp']", "input[name='goto_gc']", "button[name='goto_gc']", ".additional-checkout-button", ".google-wallet-button-holder", ".amazon-payments-pay-button"];
  checkout_selectors.forEach(function (selector) {
    //console.log("hijack checkout click")
    /*avoid jQuery: jQuery(selector).bind("click", function(ev) {
      ev.preventDefault()
      //console.log("click")
      sasoCheckout()
    })*/
    var els = document.querySelectorAll(selector)
    //console.log(els)
    if (typeof els == "object" && els) {
      for (var i = 0; i < els.length; i++) {
        var el = els[i]
        /*
        elClone = el.cloneNode(true);
        el.parentNode.replaceChild(elClone, el);
        */
        //console.log(el)
        if (typeof el.addEventListener != "function") {
          return
        }
        //remove onclick attribute
        //el.prop('onclick',null).off('click') doesn't work
        el.addEventListener('click', function (ev) {
          var did = document.getElementById("saso-use-discount-code-instead-check")
          if (typeof did == "object" && did && did.checked) {
            return true
          }
          ev.preventDefault()
          //console.log("click")

          var elsbold = document.querySelectorAll("input[name='checkout'].bold_clone")
          if (typeof elsbold == "object" && elsbold && elsbold.length) {
            //re-read cart contents, so we get product options newly added products
            jQuery.ajax({
              cache: false,
              contentType: "application/json; charset=utf-8",
              dataType: "json",
              type: "GET",
              url: '/cart.js',
              success: function (res) {
                window.saso.cart = res
                sasoCheckout()
              }
            })
          } else {
            sasoCheckout()
          }
        }, false);

        el.dataset.saso = true
        el.dataset.ocuCheckout = true //so pixel perfect ignores checkout binding, and lets us handle it
      }
    }
  })
  checkout_selectors = [".alt-payment-list-amazon-button-image"]; //can't overwrite click handling. This removes 1 image, leaves the other
  checkout_selectors.forEach(function (selector) {
    jQuery(selector).remove()
  })

}


function sasoCheckout() {

  //can be called by other apps, eg Zapiet store pickup. Need to check here if customers choose to enter a code
  //return true doesn't work. We need to actually start checkout when this is called.
  //TODO how to handle when just setting a discount code?

  if (jQuery("input[type='checkbox'].saso_agree").length > 0 && jQuery("input[type='checkbox'].saso_agree:checked").length != jQuery("input[type='checkbox'].saso_agree").length) {
    return //require terms checkbox, but only on those with class
  }

  //required attributes. Only if specifically enabled in config, otherwise it breaks some sites (mega menu contact form, Olark form...)
  if (typeof window.saso_config.force_required_fields == "boolean" && window.saso_config.force_required_fields) {
    var required_field_names = []
    var required_pass = true
    jQuery("[name^='attributes'][required]:visible").each(function () {
      if (jQuery(this).val() == "" || jQuery(this).val() == null) {
        if (jQuery(this).attr("placeholder")) {
          required_field_names.push(jQuery(this).attr("placeholder"))
        } else {
          required_field_names.push(jQuery(this).attr("name").replace("attributes[", "").replace("]", ""))
        }
        required_pass = false
      }
    })
    jQuery("textarea[required]:visible").each(function () {
      if (jQuery(this).val() == "" || jQuery(this).val() == null) {
        if (jQuery(this).attr("placeholder")) {
          required_field_names.push(jQuery(this).attr("placeholder"))
        } else {
          required_field_names.push(jQuery(this).attr("name").replace("attributes[", "").replace("]", ""))
        }
        required_pass = false
      }
    })

    if (!required_pass) {
      alert('Please fill in required fields: ' + required_field_names.join(", "))
      return
    }
  }

  /*var did = document.getElementById("saso-use-discount-code-instead-check")
  if (typeof did == "object" && did && did.checked) {
    window.location.href = "/checkout"
    return
  }*/

  var note_attributes = []
  jQuery("[name^='attributes']").each(function () {
    var $a = jQuery(this)
    //console.log(this, $a[0].tagName, $a.attr("name"), $a.val())
    var name = jQuery(this).attr("name")
    name = name.replace(/^attributes\[/i, "").replace(/\]$/i, "")
    var v = {
      name: name,
      value: $a.val()
    }
    //exclude empty values
    if (v.value == "") {
      return
    }
    switch ($a[0].tagName.toLowerCase()) {
      case "input":
        //console.log($a.attr("type"))
        if ($a.attr("type") == "checkbox") {
          //exclude unchecked, e.g. gift wrap
          if ($a.is(":checked")) {
            note_attributes.push(v)
          }
        } else {
          note_attributes.push(v)
        }
        break;
      default:
        note_attributes.push(v)
    }
  })

  //pass original discount code as attribute, but only if valid
  if (typeof window.saso.discount_code_cart == "string") {
    note_attributes.push({
      name: "discount_code",
      value: window.saso.discount_code_cart
    })
  }

  //pass special link as attribute, some stores want to know which order came from which link
  if (window.sasoDocCookies.getItem("saso_link_code")) {
    note_attributes.push({
      name: "discount_link_code",
      value: window.sasoDocCookies.getItem("saso_link_code")
    })
  }

  //pass discount details as attribute. Last one, cut when needed. Almost last, there's discount too. Cut here, to make sure
  if (typeof window.saso.discounts == "object" && typeof window.saso.discounts.cart == "object" && typeof window.saso.discounts.cart.summary_note == "string") {
    note_attributes.push({
      name: "discount_details",
      value: window.saso.discounts.cart.summary_note.substring(0, 500) //Error 414 Request URI Too Large
    })
  }


  //console.log(note_attributes)
  /*if (window.sasoDocCookies.getItem("_landing_page")) {
    var v = {
      name : "_landing_page",
      value: window.sasoDocCookies.getItem("_landing_page")
    }
    if (typeof v.value == "string" && v.value.length) {
      note_attributes.push(v)
    }
  }
  if (window.sasoDocCookies.getItem("_orig_referrer")) {
    var v = {
      name : "_orig_referrer",
      value: window.sasoDocCookies.getItem("_orig_referrer")
    }
    if (typeof v.value == "string" && v.value.length) {
      note_attributes.push(v)
    }
  }*/

  var note = ""
  if (jQuery("[name='note']").length == 1 && jQuery("[name='note']")[0].value) {
    note = jQuery("[name='note']")[0].value
  }

  if (window.saso_config.exclude_order_discount_details) {
    note_attributes = []
  }
  window.saso.cart.note_attributes = note_attributes
  window.saso.cart.note = note

  //try to get updated quantities. This will work only if there's an active discount, so sasoCheckout() is called
  for (var i = 0; i < window.saso.cart.items.length; i++) {
    var item = window.saso.cart.items[i]
    var el = document.querySelectorAll("[id='updates_" + item.key + "']")
    if (el.length != 1) {
      el = document.querySelectorAll("[id='updates_" + item.variant_id + "']")
    }
    if (el.length == 1) {
      if (el[0].value != window.saso.cart.items[i].quantity) {
        console.log("el[0].value != window.saso.cart.items[i].quantity", el[0].value)
        window.saso.cart.items[i].quantity_before_saso_update = window.saso.cart.items[i].quantity
        window.saso.cart.items[i].quantity = el[0].value
      }
    }
  }


  var invoice_url_params = []

  if (note.length) {
    invoice_url_params.push("note=" + encodeURIComponent(note))
  }

  //google analytics
  if (typeof window.gaclientId == "string") {
    invoice_url_params.push("clientId=" + window.gaclientId)
    invoice_url_params.push("_ga=" + window.gaclientId)
  }

  //Zapiet store pickup
  if (typeof Zapiet == "object" && typeof Zapiet.Cart == "object" && typeof Zapiet.Cart.getUrlParams == "function") {
    var zup = Zapiet.Cart.getUrlParams()
    if (typeof zup == "object" && zup) {
      Object.keys(zup).map(function (k) {
        //console.log(k)
        invoice_url_params.push(k + "=" + encodeURIComponent(zup[k]))
      })
    }
    if (typeof Zapiet.Widget == "object" && typeof Zapiet.Widget.checkoutEnabled == "function") {
      if (Zapiet.Widget.checkoutEnabled() == false) {
        alert('Please complete delivery info')
        return
      }
    }
    //console.log(invoice_url_params)
  }

  //optional params at end
  if (typeof window.currentLanguageCode == "string" && window.currentLanguageCode.length > 1 && window.currentLanguageCode.length < 9) {
    invoice_url_params.push("locale=" + encodeURIComponent(window.currentLanguageCode))
  }

  if (note_attributes.length) {
    note_attributes.map(function (a) {
      invoice_url_params.push("attributes" + encodeURIComponent("[" + a.name + "]") + "=" + encodeURIComponent(a.value))
    })
  }

  //if we already tried to handle checkout, but failing (server/api down...), give up, just proceed without offers
  if (typeof window.saso_config.checkout_start != "number") {
    window.saso_config.checkout_start = Date.now()
  } else {
    if (Date.now() - window.saso_config.checkout_start < 4000) {
      //keep waiting
      return
    }
    //console.log("give up")
    var invoice_url = "/checkout?discount=&clear_discount=1&discount_issue=checkout_clicked_after_3sec_delay"
    if (invoice_url_params.length) {
      invoice_url += "&" + invoice_url_params.join("&")
    }
    window.location.href = invoice_url.substring(0, 2000) //Error 414 Request URI Too Large
    return
  }


  if (window.saso_config.offers_method == "discount_code") {
    jQuery.ajax({
      cache: false,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "POST",
      url: "https://" + sasoGetHost() + "/api/v2/page-actions?checkout=discount_code",
      data: JSON.stringify(window.saso),
      success: function (res) {
        //console.log(res)
        res.invoice_url = "/checkout"

        if (typeof res.discount_code == "string") {
          invoice_url_params.unshift("discount=" + res.discount_code) //beginning, to avoid trim
          window.sasoDocCookies.setItem("saso_generated_discount_code", res.discount_code, Infinity, "/") //end of session
        }

        if (invoice_url_params.length) {
          res.invoice_url += "?" + invoice_url_params.join("&")
        }
        window.location.href = res.invoice_url.substring(0, 2000) //Error 414 Request URI Too Large

      }
    })
  } else {

    jQuery.ajax({
      cache: false,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "POST",
      url: "https://" + sasoGetHost() + "/api/v2/page-actions?checkout=draft",
      data: JSON.stringify(window.saso),
      success: function (res) {
        //console.log(res)
        //if no discounts, redirect to checkout, but with params
        if (typeof res.invoice_url != "string") {
          res.invoice_url = "/checkout"
        }
        //this is set only when there are discounts
        var did = document.getElementById("saso-use-discount-code-instead-check")
        if (typeof did == "object" && did && did.checked) {
          res.invoice_url = "/checkout"
        }

        if (invoice_url_params.length) {
          res.invoice_url += "?" + invoice_url_params.join("&")
        }
        //Draft invoice takes time to work
        setTimeout(function () {
          window.location.href = res.invoice_url.substring(0, 2000) //Error 414 Request URI Too Large
        }, 1000)

      }
    })
  }
}


function sasoUseDiscountCodeCartApply() {
  //previous code was using id, but some themes have 2 carts (mobile & desktop), we need to use class and keep id working too
  var code = ""
  if (jQuery("#saso-use-discount-code-cart-code").length) {
    code = jQuery("#saso-use-discount-code-cart-code").val()
  } else if (jQuery(".saso-use-discount-code-cart-code").length) {
    //which one is filled in?
    jQuery(".saso-use-discount-code-cart-code").each(function () {
      if (jQuery(this).val() != "") {
        code = jQuery(this).val()
      }
    })
  }
  code = code.trim()
  if (code.length == 0) {
    window.sasoDocCookies.removeItem("saso_discount_code")
  } else {
    window.sasoDocCookies.setItem("saso_discount_code", code, "/") //end of session
  }
  window.location.reload()
}

// set free gift items qty to 1 or 0. buy 1 get 1 free too, can't remove free item when just 1, auto-added back
function sasoUseDiscountCodeInsteadChange() {
  var did = document.getElementById("saso-use-discount-code-instead-check")
  if (typeof did != "object" || !did) {
    return
  }
  var qty = 1
  if (did.checked) {
    //console.log("use")
    qty = 0
    jQuery(".saso-cart-total").hide()
    jQuery(".saso-cart-original-total").css("text-decoration", "none")
    jQuery(".saso-summary-line-buyxgety").css("display", "none")
    window.sasoDocCookies.setItem("saso_use_discount_code_instead", true, Infinity, "/") //end of session
  } else {
    jQuery(".saso-cart-total").show()
    jQuery(".saso-cart-original-total").css("text-decoration", "line-through")
    jQuery(".saso-summary-line-buyxgety").css("display", "inline")
    window.sasoDocCookies.removeItem("saso_use_discount_code_instead", "/")
    location.reload() //apply offers
  }

  if (typeof window.saso.discounts != "object" || typeof window.saso.discounts.cart != "object" || typeof window.saso.discounts.cart.items != "object") {
    return
  }
  for (var i = 0; i < window.saso.discounts.cart.items.length; i++) {
    var item = window.saso.discounts.cart.items[i]
    if (typeof item.offer_type != "string" || item.offer_type != "Free Gift") {
      continue
    }
    if (item.discounted_price > 0) {
      continue //leave gift items which aren't discounted, maybe customers want to purchase them
    }
    var el = document.querySelectorAll("[id='updates_" + item.key + "']")
    if (el.length != 1) {
      el = document.querySelectorAll("[id='updates_" + item.variant_id + "']")
    }
    if (el.length == 1) {
      el[0].value = qty
    }

  }

}


function sasoShowVolumeDiscountTiers(data) {
  //console.log("sasoShowVolumeDiscountTiers", data, jQuery(".saso-volumes").length)
  /* not needed if Add to cart isn't used in pricing grid
  if (window.sasoc.$first_add_to_cart_el == null) {
    return
  }*/
  //cache for variant reload
  if (typeof data == "object") {
    window.saso_extras.volume_discount_tiers = data
  } else if (typeof window.saso_extras.volume_discount_tiers == "undefined") {
    //customer changed variants, but no tiers
    return
  }
  if (typeof data == "undefined") {
    //variant changed
    data = window.saso_extras.volume_discount_tiers
    if (typeof window.saso_extras.product.variants == "object") {
      var variant = window.saso_extras.product.variants.filter(function (v) { return v.id == window.saso_extras.current_variant_id })
      if (variant.length == 1) {
        window.saso.product.price = variant[0].price
        //console.log(variant[0])
      }
    }
  }

  //some merchants want to show prices as $, even if % Off. Some want to show different label if % Off, e.g. discount
  var price_type = "flat" //used in template
  //copy, so that price type subtract is re-computed to flat on product change
  var tiers_copy = JSON.parse(JSON.stringify(data.tiers))

  for (var i = 0; i < tiers_copy.length; i++) {
    var price = tiers_copy[i].price
    if (typeof window.saso_config.translate_percent_off == "string") {
      price.title = price.title.replace("% Off", window.saso_config.translate_percent_off)
    }
    if (price.type == "subtract") {
      //change to flat, with proper amount
      price.type = "flat"
      price.amount = window.saso.product.price - (price.amount * 100)
      price.title = '<span class="saso-price">' + sasoShopifyformatMoney(price.amount, window.saso.money_format) + '</span>'
    }

    var pf = JSON.parse(JSON.stringify(price)) //copy
    if (price.type == "percent") {
      price_type = "percent"
      pf.amount = window.saso.product.price * (100 - data.tiers[i].price.amount) / 100
      pf.title = '<span class="saso-price">' + sasoShopifyformatMoney(pf.amount, window.saso.money_format) + '</span>'
      //console.log(window.saso.product.price, data.tiers[i].price.amount, pf.amount)
    }
    tiers_copy[i].price_amount = price.amount
    tiers_copy[i].price_flat = pf
    tiers_copy[i].price_line = JSON.parse(JSON.stringify(pf))
    tiers_copy[i].price_line.amount = tiers_copy[i].price_line.amount * tiers_copy[i].quantity
    tiers_copy[i].price_line.title = '<span class="saso-price">' + sasoShopifyformatMoney(tiers_copy[i].price_line.amount, window.saso.money_format) + '</span>'
  }

  var tpl = Handlebars.compile(jQuery('#saso-volume-discount-tiers').html())
  var tpl_data = {
    product_message: data.product_message,
    tiers: tiers_copy,
  }
  tpl_data["price_type_" + price_type] = price_type
  var html = tpl(tpl_data)

  jQuery(".saso-volumes").html(html)
  sasoCurrency()
}

function sasoVolumesAddToCart(ev) {
  ev.preventDefault() //cart is submitted when inside <form>
  //jQuery("[name='quantity']").val(jQuery(this).data("quantity")) //it won't work when quantity is a select field
  jQuery("[name='quantity']").remove() //might not even be present
  window.sasoc.$first_add_to_cart_el.after("<input type='hidden' name='quantity' value='" + jQuery(this).data("quantity") + "'>")
  window.sasoc.$first_add_to_cart_el.click()
  //why not add to cart via JS? because we want the theme's button behaviour, e.g. show a message, or redirect to cart
}


function sasoUpsellAddToCart(ev) {
  ev.preventDefault() //cart is submitted when inside <form>
  var product_id = jQuery(this).data("product-id")
  var variant_id = jQuery(this).data("variant-id")
  var $variants = jQuery(".saso-product-container[data-product-id='" + product_id + "']").find("select.saso-variants")
  if ($variants.length == 1) {
    var variant_id = parseInt($variants.val())
    if (variant_id == 0) {
      alert(window.saso_config.upsell_variant_choose_message)
      return
    }
  }

  //let it finish first
  sasoRemovePreviousFreeGifts(function () {
    jQuery.ajax({
      type: "POST",
      dataType: "json",
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: variant_id,
      },
      success: function (res) { //done_data is empty, no data returned
        window.saso.upsell_added = true

        //don't show this upsell for a while
        //sasoShowCrossSellShown(product_id)
        sasoShowCrossSellClosed()

        //reload if embedded in cart, or upsell was showing discounted prices, or bundle
        var a = window.saso.action_crosssell_popup_action

        if ((window.sasoc.$cart_offers && window.sasoc.$cart_offers.length)
          || (typeof a.price_discount == "object" && a.price_discount && typeof a.price_discount.amount == "number")
          || (typeof a.price_bundle == "object" && a.price_bundle)
        ) {
          //sometimes cart doesn't actually contain the product??
          setTimeout(function () {
            window.location.href = "/cart" //might be in ajax cart, so always "reload" and show to customers that product has been added
          }, 100)
        } else {
          //don't close popup, allow adding more products. Just hide newly added product
          jQuery(".saso-product-container[data-product-id=" + product_id + "]").fadeOut("slow", function () {
            jQuery(".saso-product-container[data-product-id=" + product_id + "]").remove() //we have set display table cell important, so hiding isn't enough
            //any items left?
            //console.log(jQuery(".saso-product-container:visible").length) //this is 0
            if (jQuery(".saso-product-container:visible").length == 0) {
              window.sasoc.magnificPopup.instance.close() //doesn't always work, so try to click too? don't use without "instance"
              //jQuery(".mfp-close").click()
            }
          })


          if (window.saso_config.crosssell_close_after_one_add) {
            window.sasoc.magnificPopup.instance.close()
            //jQuery(".mfp-close").click()
          }

        }
      },
      error: function (res) {
        //console.log("err", res)
        if (typeof res == "object" && typeof res.responseJSON == "object" && typeof res.responseJSON.description == "string") {
          alert(res.responseJSON.description)
        }
        if (typeof res == "string") {
          alert(res)
        }

      }
    })
  })

}


//if adding a free gift, and Settings > Apply only one Free Gift offer, remove the previous free gift if such a line existed.
//Remove by variant id, not line no, as that will change
function sasoRemovePreviousFreeGifts(callback) {
  if (typeof window.saso.discounts != "object" || typeof window.saso.discounts.cart != "object" || typeof window.saso.discounts.cart.items != "object") {
    return callback()
  }
  if (typeof window.saso.discounts.multiple_offers_free_gift != "string" || window.saso.discounts.multiple_offers_free_gift != "one") {
    return callback()
  }

  if (typeof window.saso.ignore_previous_free_gifts == "boolean" && window.saso.ignore_previous_free_gifts) {
    return callback()
  }
  //we just added a gift, so remove all existing
  //console.log("we just added a gift, so remove all existing")
  //console.log(JSON.stringify(window.saso.discounts.cart.items))
  var itemsfg = window.saso.discounts.cart.items.filter(function (item) {
    return (typeof item.offer_type == "string" && item.offer_type == "Free Gift") // item.discounted_price will not be 0, since new gift tier is already used
  })
  //console.log(itemsfg)
  var updates_request = []
  itemsfg.map(function (item) {
    //console.log(item)
    updates_request.push("updates[" + item.variant_id + "]=0")
  })

  if (updates_request.length == 0) {
    return callback()
  }

  //by using callback, this will complete before cart reload requested by add
  jQuery.ajax({
    type: "POST",
    dataType: "text",
    url: '/cart/update.js',
    data: updates_request.join(","),
    success: function (done_data) {
      return callback()
    }
  })
}


//called on cart items change
function sasoOnAjaxComplete(event, xhr, settings) {
  /*console.log(event)
console.log(xhr)
console.log(settings)*/
  if (typeof settings == "object" && typeof settings.url == "string") {
    if (settings.url == "/cart/change.js") {
      window.location.reload()
    }
  }
}


function sasoGetHost() {
  return "specialoffers.suppleapps.com"
}

function sasoStart() {

  /* client only vars, don't pass to server */
  window.sasoc = {
    magnificPopup: jQuery.magnificPopup,
    $cart_offers: jQuery(".saso-cart-offers"),
  }

  if (window.sasoDocCookies.getItem("saso_link_code")) {
    window.saso.only_special_link_code = window.sasoDocCookies.getItem("saso_link_code")
  }

  //allow referral links to set a code -- in .liquid, so it works on any page
  if (window.sasoDocCookies.getItem("saso_discount_code")) {
    window.saso.discount_code_cart = window.sasoDocCookies.getItem("saso_discount_code").toLowerCase().trim()
  }


  if (window.sasoDocCookies.getItem("saso_generated_discount_code")) {
    //customer went back to cart, delete old code
    //include it in the next call, no need for a separate API
    window.saso.saso_generated_discount_code = window.sasoDocCookies.getItem("saso_generated_discount_code")
    /*jQuery.ajax({
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        type: "POST",
        url: "https://" + sasoGetHost() + "/api/v1/delete-discount-code",
        data: JSON.stringify({discount_code: window.sasoDocCookies.getItem("saso_generated_discount_code")}),
        success: function(res) {
          //console.log("YES")
        }
      })*/
    window.sasoDocCookies.removeItem("saso_generated_discount_code")
  }

  //legacy templates
  window.saso_magnificPopup = window.sasoc.magnificPopup


  /* auto-add cart container -- dont. cust feedback: The special offer used to be a pop-up on my store, now it’s embedded on the cart page and not nearly as effective */
  /*if (window.saso.page_type == "cart" && window.sasoc.$cart_offers.length == 0) {

    var forms = jQuery("form[action='/cart']")
    if (forms.length == 0) {
      forms = jQuery("form[action='/checkout']")
    }
    if (forms.length == 0) {
      console.log("couldn't find cart form")
    } else {
      // <form action="/cart" -- the last one, some themes include one in header
      jQuery(forms[forms.length - 1]).prepend('<div class="saso-cart-offers"></div>')
    }
    window.sasoc.$cart_offers = jQuery(".saso-cart-offers")
  }*/

  //force clearing previous discount codes, if customer started checkout and then went back to cart to remove items
  jQuery('<input>').attr({
    type: 'hidden',
    name: 'discount',
    value: ''
  }).appendTo("form[action='/cart']")
  jQuery('<input>').attr({
    type: 'hidden',
    name: 'clear_discount',
    value: '1'
  }).appendTo("form[action='/cart']")

  setTimeout(function () {

    window.sasoc.$first_add_to_cart_el = null
    //any Add to cart might trigger Upsell
    /*
    mega-menu has .widget-product with Add to cart form in them, exclude those -- doesn't have name=, it's ok
    */
    //jQuery(".widget-product input[name='add']").addClass("saso-ignore")

    var selectors = ["input[name='add']:not(.saso-ignore)", "button[name='add']:not(.saso-ignore)", "#add-to-cart", '#AddToCartText', '#AddToCart', '#addToCart', "button[value='Add to cart']", "button[value='Add to Cart']", "input[value='Add to cart']", "input[value='Add to Cart']", "button.addtocart"]
    var found_selectors = 0
    selectors.forEach(function (selector) {
      found_selectors += jQuery(selector).length
      //could be multiple on page, e.g. related products. Use only the first
      if (window.sasoc.$first_add_to_cart_el == null && found_selectors) {
        window.sasoc.$first_add_to_cart_el = jQuery(selector).first()
      }
      if (window.saso_config.crosssell_popup_on_add) {
        jQuery(selector).on("click", function (e) {
          //console.log("saso add click")
          window.saso.action_crosssell_el = { $el: jQuery(this) }
          window.saso.action_crosssell_el.variant_id = null
          var ids = window.saso.action_crosssell_el.$el.parents("form:first").find("[name='id']")
          //console.log("ids", ids)
          if (ids.length == 1) {
            window.saso.action_crosssell_el.variant_id = jQuery(ids[0]).val()
          }
          //for_product_id: window.saso.product.id,
          sasoShowCrossSell({ variant_id: window.saso.action_crosssell_el.variant_id })
        })
      }
    })
    if ((window.saso.page_type == "collection" || window.saso.page_type == "product") && found_selectors == 0) {
      //console.log("saso warning: no add selectors found")
    }

    if (jQuery(".saso-summary").length == 0 && jQuery(".saso-cart-total").length > 0) {
      //jQuery(".saso-cart-original-total").parents("div").eq(0).prepend('<div class="saso-summary"></div>')
      //console.log(jQuery(".saso-cart-total").length )
      jQuery('<div class="saso-summary"></div>').insertBefore(".saso-cart-total")
    }

    //do not add both containers at the same time, some developers put only 1 container and expect it to work
    if (window.saso.page_type == "product" && (jQuery(".saso-volumes").length == 0 || jQuery(".saso-bundle").length == 0)) {
      var vol_el_after = null

      //some themes need special placement
      //https://topmunch.com/collections/shop/products/japan-amanoya-himemaru-rice-cracker
      //if reviews in form, add after Add to cart button, not after form, to be closer to Add ???
      /*if (jQuery('form[action="/cart/add"]').length >= 1
          && (jQuery("form .review_row.clearfix").length == 0)) {
        vol_el_after = jQuery('form[action="/cart/add"]').first()
      } */
      /*      else if (jQuery(".selection-wrapper.cart").length == 1) {
              vol_el_after = jQuery(".selection-wrapper.cart").first()
            } */
      //after add to cart button
      //https://shop.muscletech.com/collections/90-servings-of-vaporx5-next-gen-for-59-99/products/vaporx5-next-gen
      /*else */
      if (window.sasoc.$first_add_to_cart_el != null) {
        vol_el_after = window.sasoc.$first_add_to_cart_el
        //console.log("vol_el_after", vol_el_after)
        if (vol_el_after.parent().is('div')) {
          vol_el_after = vol_el_after.parent()
        }
      }
      if (vol_el_after && jQuery(".saso-volumes").length == 0) {
        vol_el_after.after('<div class="saso-volumes"></div>')
      }
      if (vol_el_after && jQuery(".saso-bundle").length == 0) {
        vol_el_after.after('<div class="saso-bundle"></div>')
      }
    }




    jQuery('body').on('click', '.saso-volume-discount-tiers .saso-add-to-cart', sasoVolumesAddToCart)
    jQuery('body').on('click', '.saso-cross-sell-popup .saso-add-to-cart:not(.saso-bundle-add-to-cart)', sasoUpsellAddToCart)
    jQuery('body').on('click', '.saso-bundle-add-to-cart', sasoBundleAddToCart)
    //legacy templates, we can't update but need to keep working: .add-to-cart
    jQuery('body').on('click', '.saso-volume-discount-tiers .add-to-cart', sasoVolumesAddToCart)
    jQuery('body').on('click', '.saso-cross-sell-popup .add-to-cart', sasoUpsellAddToCart)
    jQuery('body').on('click', '#saso-use-discount-code-cart-apply', sasoUseDiscountCodeCartApply)
    jQuery('body').on('click', '.saso-use-discount-code-cart-apply', sasoUseDiscountCodeCartApply)
    jQuery('body').on('change', '#saso-use-discount-code-instead-check', sasoUseDiscountCodeInsteadChange)



    jQuery('body').on('click', '.saso-crosssell-nav', function () {
      //console.log("saso-crosssell-nav", jQuery(this).data("product-id"))
      //console.log("saso-cross-sell-popup variant id", saso_product_id)
      //for reporting, log in our db that a product was chosen
      var saso_product_id = jQuery(this).data("product-id")
      jQuery.ajax({
        type: "POST",
        dataType: "json",
        url: "https://" + sasoGetHost() + "/api/v1/cross-sell-add",
        data: {
          shop_slug: window.saso.shop_slug,
          product_id: saso_product_id,
          cart_token: window.saso.cart.token,
        },
        success: function (done_data) { }
      })
    })

    //upsell popup: change image to selected variant
    jQuery('body').on('change', '.saso-variants', function (ev) {
      //console.log(jQuery(ev.target).val())
      var img = jQuery(this).find(':selected').data('img')
      if (typeof img == "string" && img.length) {
        //console.log(img)
        //console.log(jQuery(ev.target).closest(".saso-product-container"))
        jQuery(ev.target).closest(".saso-product-container").find("img").attr("src", img)
      }

      var price = sasoShopifyformatMoney(jQuery(this).find(':selected').data('price'), window.saso.money_format)
      var compare_at_price = sasoShopifyformatMoney(jQuery(this).find(':selected').data('compare-at-price'), window.saso.money_format)
      //console.log(price, compare_at_price)
      jQuery(ev.target).closest(".saso-product-container").find(".saso-price").html(price)
      jQuery(ev.target).closest(".saso-product-container").find(".saso-was-price").html(compare_at_price)
      sasoCurrency()
    })


    if (window.saso.page_type == "cart") {
      jQuery(document).ajaxComplete(sasoOnAjaxComplete)

      //auto-reload cart on quantities change, except when asked to ignore
      //doesn't work...
      jQuery('body').on('change', 'input[name="updates[]"]:not(.saso-ignore)', function (ev) {
        jQuery('[name="update"]').click()
      })


      //venture
      /*jQuery('body').on('click', 'button.js-qty__adjust:not(.saso-ignore)', function(ev) {
        //leave time to update cart, it updates cart and only later quantity
        setTimeout(function() {
          jQuery('[name="update"]').click()
        }, 500) doesn't work
      })*/
      setTimeout(function () {
        if (typeof window.QtySelector == "function") {
          window.QtySelector.prototype.updateCartItemCallback = function (cart) {
            location.reload()
          }
        }
      }, 2000)

    }


    //prevent direct checkouts from popups, quick view... in .liquid


    //legacy templates use .close, newer use .saso-close to avoid theme's class overwrites
    jQuery('body').on('click', '.saso-cross-sell-popup .close', function (ev) {
      ev.preventDefault() //cart is submitted when inside <form>
      window.sasoc.magnificPopup.instance.close()
    })
    jQuery('body').on('click', '.saso-cross-sell-popup .saso-close', function (ev) {
      ev.preventDefault() //cart is submitted when inside <form>
      if (typeof window.saso.action_crosssell_popup_action == "object") {
        window.saso.action_crosssell_popup_action.manually_closed = true
      }
      window.sasoc.magnificPopup.instance.close()
    })


  }, 1) //no need to wait, we're included at the end. If we wait more, offers will run and won't find elements in page


  if (window.saso.page_type == "product") {
    //set current variant, to be used by Volume
    if (typeof window.saso_extras.product.variants == "object") {
      //default to 1st
      window.saso_extras.current_variant_id = window.saso_extras.product.variants[0].id
    }
    //if (window.location.href.indexOf("variant=") > -1) {
    if (sasoGetParameterByName("variant") != "") {
      window.saso_extras.current_variant_id = parseFloat(sasoGetParameterByName("variant")) //window.location.href.match(/variant=([0-9]+)/)[1] fails when multiple variant= parameters
    }
    //set product price to the current variant
    if (typeof window.saso_extras.current_variant_id == "number" && typeof window.saso_extras.product.variants == "object") {
      var variant = window.saso_extras.product.variants.filter(function (v) { return v.id == window.saso_extras.current_variant_id })
      if (variant.length == 1) {
        window.saso.product.price = variant[0].price
      }
    }
  }


  //send list of shown upsells to server, to exclude those
  var cooka = []
  var cook = window.sasoDocCookies.getItem("saso_shown_upsells")
  if (cook && typeof cook == "string") {
    cooka = cook.split(",")
  }
  window.saso.saso_shown_upsells = cooka

  //needs to be after use discount code checkbox was rendered, but that implies auto-adding free products. So render it here.
  if (window.saso.page_type == "cart") {
    if (window.sasoDocCookies.getItem("saso_use_discount_code_instead")) {
      //render checkbox as checked and stop

      var html_d = '<div><label style="font-weight: normal; cursor: pointer;"><input type="checkbox" id="saso-use-discount-code-instead-check"> I will be using a discount code instead</label></div>'
      if (jQuery('#saso-use-discount-instead').length == 1) {
        html_d = jQuery('#saso-use-discount-instead').html()
      }
      jQuery(".saso-summary").html(html_d)

      if (document.getElementById("saso-use-discount-code-instead-check")) {
        document.getElementById("saso-use-discount-code-instead-check").checked = true
        //no offers check, so customers can remove from cart Get Y free items
      }
      return
    }
  }

  jQuery.ajax({
    cache: false,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    type: "POST",
    url: "https://" + sasoGetHost() + "/api/v2/page-actions",
    data: JSON.stringify(window.saso),
    success: function (data) {
      //jQuery(document).ready() doesn't trigger on some sites
      setTimeout(function () {
        sasoDoActions(data)
      }, 1) //no delay, we are loaded at the end, after all DOM
    }
  })

  setTimeout(function () {
    //can't overwrite onclick on these.
    if (jQuery("button[onclick=\"window.location='/checkout'\"]").length) {
      console.log("WARNING: buttons with onclick=\"window.location='/checkout'\" will skip Ultimate Special Offers. Replace with /cart instead.")
    }
  }, 1000)

}



sasoStart()

setTimeout(function () {
  //wait for GA to load
  if (typeof ga == "function") {
    ga(function (tracker) {
      window.gaclientId = tracker.get('clientId')
    })
  }
}, 1000)

/*
Thinking about including at the top, after <body>, to get quicker control. Some people click checkout too fast?
all dom-elements interaction, which aren't on body, would have to be delayed, and maybe repeated attempts

downside: jquery might be loaded at end of body, we'll load it again. Maybe drop jQuery... try to use it only for ajax

*/

if (typeof window.history == "object") {
  (function (history) {
    var replaceState = history.replaceState;
    history.replaceState = function (state) {
      var rs_arguments = arguments
      //console.log(rs_arguments)
      //wait a little, so href is updated to current value
      setTimeout(function () {
        //state is empty sometimes, use href
        //console.log("test1", state)
        if (typeof sasoCheckout == "function" && typeof window.saso.page_type == "string" && window.saso.page_type == "product") {
          //console.log("test2")
          if (window.location.href.indexOf("variant=") > -1) {
            //console.log("test3")
            window.saso_extras.current_variant_id = parseFloat(window.location.href.match(/variant=([0-9]+)/)[1])
            sasoShowVolumeDiscountTiers()
            //console.log(window.saso_extras.current_variant_id, state.path)
          }
        }
      }, 300)
      //console.log(rs_arguments)
      return replaceState.apply(history, rs_arguments);
    }
  })(window.history);
}
